import React, { useState } from 'react';
import '../../scss/reset_password.scss';
import eyeicon from '../../images/login/eyeicon.png';
import { useNavigate, useLocation } from 'react-router-dom';
import Snackbars from '../Reusables/Snackbar';
import clairvoyix from '../../images/project/clairvoyix-image.gif'
import getCommonResponse from '../actions/Common';
import { trim } from '../Reusables/Function';

function ForgotPassword(props) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [enable, setEnable] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(null);
    const [emailSent, setEmailSent] = useState(false);

    const getEmail = (email) => {
        setEmail(email);
    }

    const ForgotPassword = () => {
        if(email != "") {
            setEnable(false);
            var details = {
                Email: trim(email)
            }

            const URL = `/api/users/forgot-password`;
            getCommonResponse.PostDetailsWithApiKey(URL, details, (response) => {  
                setEnable(true)
                if(response.status == 200) {
                    setEmailSent(true);
                } else {
                    setOpen(true);
                    setError(response.data.message)
                }
            });
        } else {
            setOpen(true);
            setError("Email is mandatory")
        }
    }

    const backToLogin = () => {
        navigate('/');
    }


    return (
        <div className='forgot-password-container'>
            <div className='header'>
                <div className='header-left'>
                    <img src={clairvoyix}></img>
                </div>
            </div>
            <div className='forgot-password-sub-container'>
 
                <div className='forgot-password-section'>
                    {!emailSent ? 
                    <div className='email-section'>
                        <h3>Forgot Password?</h3>
                        <p>Enter the email address associated with your account</p>
                        <div className='email-container'>
                            <input type='email' name='email' className='email' placeholder='Email' onChange={(e) => getEmail(e.target.value)}></input>
                        </div>
                        <button disabled={!enable} className={`send-mail-button ${enable ? 'button-enable' : 'button-disable'}`} onClick={ForgotPassword}>Send Mail</button> 
                    </div> : 
                    <div className='success-message'>
                        Reset Password link has been sent to the email address you provided!
                    </div>}
                    <div>
                        <div onClick={backToLogin} className='back-to-login'><span>&#8592; </span>Back to log in</div>
                    </div>
                </div>  

                <Snackbars error={error} open={open} setOpen={setOpen}/>
            </div>
        </div>
    );
}

export default ForgotPassword;